/*
 Created by CHT 2020/10/11 11:35
 */

import BaseItem from "../BaseItem"
import {
  DATA_TYPE__ARRAY, DEFAULT_VALUE__CUSTOM,
  DEFAULT_VALUE__IMAGE,
  FORM_ITEM__IMAGE, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit} from "../utils"
import {uuid} from "../utils"

class ImageAttachment extends BaseItem {
  constructor() {
    super()

    this.value = []

    this.uploadOneOnly = 0   // 只允许上传1个 0否 1是
    this.photoOnly = 0 			 // 只允许拍照上传
    this.sizeLimit = 0 			 // 是否限制大小 0 否 1是
    this.limitSize = 500     // 限制上传大小 KB
    this.autoCompress = 0    // 是否自动压缩
    this.openWaterMark = "NO" //开启水印 YES NO
    //开启水印
    this.waterMarkConfig = {
      "position": "NorthWest", //水印位置
      "color": "", //颜色
      "fontSize": "S", //文本大小 小 S 中 M 大 L 特大 XL
      "dissolve": "100", //透明度，取值范围1-100，默认值100（完全不透明）。
      "content": ""
    }

    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || ImageAttachment._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

ImageAttachment._title = '图片'
ImageAttachment.type = FORM_ITEM__IMAGE
ImageAttachment.icon = 'iconfont icon-tupian'
ImageAttachment.use = true

ImageAttachment.prototype.type = ImageAttachment.type
ImageAttachment.prototype.dataType = DATA_TYPE__ARRAY
ImageAttachment.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: '自定义',
    value: defaultValueInit(DEFAULT_VALUE__IMAGE)
  }
]

ImageAttachment.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
ImageAttachment.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
ImageAttachment.prototype.getValue = function () {
  for (let i = this.value.length - 1; i > 0; i--) {
    const item = this.value[i]
    if (!item || !item.imgUrl) {
      this.value.splice(i, 1)
    }
    delete item.status
    delete item.uploadTime
  }
  return this.value
}
ImageAttachment.prototype.appendValue = function (val) {
  if (!val) {
    return
  }
  val.forEach(item => {
    const existItem = this.value.filter(img => img.id === item.id)[0]
    if (existItem) {
      existItem.imgName = item.imgName
      existItem.imgSize = item.imgSize
      existItem.imgUrl = item.imgUrl
      existItem.status = 'success'
    } else {
      this.value.push(item)
    }
  })
}
ImageAttachment.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.uploadOneOnly) this.uploadOneOnly = opts.uploadOneOnly
  if (opts.photoOnly) this.photoOnly = opts.photoOnly
  if (opts.sizeLimit) this.sizeLimit = opts.sizeLimit
  if (opts.limitSize) this.limitSize = opts.limitSize
  if (opts.autoCompress) this.autoCompress = opts.autoCompress
  if (opts.openWaterMark) this.openWaterMark = opts.openWaterMark
  if (opts.waterMarkConfig) this.waterMarkConfig = opts.waterMarkConfig
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__IMAGE) {
      this.value = this.defaultValue.imgs
    }
  }
}
ImageAttachment.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    uploadOneOnly: this.uploadOneOnly,
    photoOnly: this.photoOnly,
    sizeLimit: this.sizeLimit,
    limitSize: this.limitSize,
    autoCompress: this.autoCompress,
    openWaterMark: this.openWaterMark,
    waterMarkConfig: this.waterMarkConfig,
    defaultValue: this.defaultValue
  }
}
ImageAttachment.prototype.createFileInfo = function (file) {
  return {
    imgName: file.name,
    imgSize: (file.size / 1000).toFixed(2),  // KB
    imgUrl: '',
    id: uuid('IMAGE')
  }
}
ImageAttachment.prototype.valueToString = function (value) {
  value = value || this.value
  return value.map(img => img.imgName).join('、')
}
export default ImageAttachment
